import { useContext } from "react";

import type { ITransferContext } from "@/contexts/TransferContext";
import { TransferContext } from "@/contexts/TransferContext";

// NOTE: NSAI-7067 — reads the app-level transfer list (uploads plus connector
// fetches). Any page can observe or cancel a transfer without owning it.
export const useTransfers = (): ITransferContext => {
  const context = useContext(TransferContext);

  // NOTE: this guard ensures the hook is used within its required provider and does not need test coverage.
  /* istanbul ignore next */
  if (context === null) {
    throw new Error("useTransfers must be used within a TransferProvider");
  }

  return context;
};
